import * as ApiWithToken from "../callApiWithToken";

const reportsService = {
    getReportListEndPoint: async function (languageID: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `Reports/GetReportList?idLanguage=${languageID}`);
    },
    getReportEndPoint: async function (sp: string, startDate: string, endDate: string, languageID: number) {
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&startDate=${startDate}&endDate=${endDate}`);
    },
    getReportWeeklyEndPoint: async function (sp: string, weekDate: string, languageID: number) {
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&weekDate=${weekDate}`);
    },
    getReportMonthlyEndPoint: async function (sp: string, monthDate: string, languageID: number) {
        return ApiWithToken.getApiBlob(process.env.REACT_APP_SURVEY_API + `Reports/${sp}?idLanguage=${languageID}&monthDate=${monthDate}`);
    }
}
export default reportsService;
